import { faEdit } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Formik } from 'formik';
import { observer } from 'mobx-react';
import { useContext, useState } from 'react';
import { Button, Modal } from 'react-bootstrap';
import { storesContext } from '../../../../stores/storesContext';
import { errorToast, successToast } from '../../../helpers/toasts/ToastUtils';
import PackhouseAssessmentForm from './PackhouseAssessmentForm';

const UpdatePackhouseAssessmentModal = ({
  monitoringBlock,
  packhouseAssessment
}) => {
  const userStore = useContext(storesContext);
  const alcmStore = userStore.alcmStore;

  const [open, setOpen] = useState(false);

  const show = () => setOpen(true);
  const hide = () => setOpen(false);

  return (
    <>
      <Button
        variant='link'
        size='sm'
        onClick={() => {
          show();
        }}
      >
        <FontAwesomeIcon icon={faEdit} />
      </Button>
      <Modal backdrop='static' size='md' show={open} onHide={() => hide()}>
        <Modal.Header closeButton>
          <Modal.Title>Update Packhouse Assessment</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Formik
            validateOnChange={false}
            validateOnBlur={false}
            initialValues={{
              block_id: monitoringBlock.id,
              date: packhouseAssessment.date,
              hpaw_result: packhouseAssessment.hpaw_result,
              qc_result: packhouseAssessment.qc_result
            }}
            validate={(values) => {
              const errors = {};
              if (!values.date) errors.date = 'Required';
              if (!values.hpaw_result) errors.hpaw_result = 'Required';
              if (!values.qc_result) errors.qc_result = 'Required';
              return errors;
            }}
            onSubmit={async (values, actions) => {
              try {
                await alcmStore.updatePackhouseAssessment(
                  packhouseAssessment.id,
                  {
                    block_id: values.block_id,
                    date: values.date,
                    hpaw_result: values.hpaw_result,
                    qc_result: values.qc_result
                  }
                );
                successToast('Packhouse Assessment updated successfully.');
                hide();
              } catch (err) {
                errorToast('Failed to updated packhouse assessment.');
              } finally {
                actions.setSubmitting(false);
              }
            }}
          >
            {() => {
              return <PackhouseAssessmentForm onCancel={hide} />;
            }}
          </Formik>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default observer(UpdatePackhouseAssessmentModal);

